<template>
    <div>
        <div v-if="relationshipField==='contact'">
            
            <div>
                <div class="font-md mb-3 font-weight-bold">{{$ml.get('ADD_PERSON')}}</div>
            </div>
            <div class="row">
                <div class="col-12">
                    <label class="new-label font-weight-bold">{{$ml.get('COMPANY_TO_BE_ADDED')}}</label>
                    <div class="row" v-if="organization!==undefined">
                        <div class="col-12" v-if="organization.name!==undefined">
                            <input type="text" class="new-input" disabled :value="organization['name']">
                        </div>
                        
                    </div>
                </div>
                <div class="col-12">
                    <label class="new-label font-weight-bold">{{$ml.get('CONTACT_TO_BE_ADDED')}}</label>
                    <input type="text" v-model="contactKeyword" @click="quickContact(),isHiddenOrganization=false" @blur="isHiddenOrganization=false" class="new-input">
                    <ul class="new-dropdown autocomplete-results" v-show='items.length>0 && isHiddenContact'>
                        <li class="autocomplete-result" v-for='(result, i) in items' :key="i" @click="setResult(result,'contact')">{{result.n}} {{result.sn}} <span v-if="result.organizationName!=undefined" class="color-red">({{filterName(result.organizationName)}})</span><span v-else class="color-red">(Firma Yok)</span></li>
                    </ul>
                    <ul class="new-dropdown autocomplete-results" v-show="items.length<1 && isHiddenContact">  
                        <li class="autocomplete-result"> {{$ml.get('NOT_FOUND_PERSON')}}</li>
                        <li class="autocomplete-result f-w-normal font-family-bold f-14 color-primary" @click="addContact=true,isHiddenContact=false"> {{$ml.get('ADD_PERSON')}} <i class="fa fa-plus float-right color-primary"></i></li>
                    </ul>
                    <div v-if="dedectedOrganization">
                        <label class="f-14 font-family-bold f-w-normal text-danger">Bu Kişi <u>{{selectOrganization}}</u> firmasında zaten mevcuttur. Devam ederseniz değiştirirsiniz!</label>
                    </div>
                </div>
                <div v-show="addContact" class="col-12">
                    <div class="row addContact">
                        <div class="col-12 d-flex justify-content-between align-items-center fastAdd">
                            <label class="h-36 py-2 m-0"> {{$ml.get('QUICK_ADD_CONTACT')}}</label>
                            <span class="fa fa-close font-m cursor-pointer" @click="closeContactButton" ></span>
                        </div>
                        <div class="col-12">
                            <label class="new-label">{{$ml.get('NAME')}} {{$ml.get('SURNAME')}}* </label>
                            <input type="text" v-model="addContactArray['name']" :placeholder="addContactArray['name']"  class="new-input">
                        </div>
                        <div class="col-12">
                            <label class="new-label">Gsm*</label>
                            <input type="number" onwheel="this.blur()" v-model="addContactArray['gsm']"  class="new-input">
                        </div>
                        <div class="col-12">
                            <label class="new-label">{{$ml.get('E_MAIL')}}*</label>
                            <input type="text" v-model="addContactArray['mail']"  class="new-input">
                        </div>
                        <div class="col-12 organizationBtnStyle my-2">
                            <button @click="saveContactButton" class="btn-new save mcBgDark">{{$ml.get('SAVE')}}</button>
                            <button @click="closeContactButton" class="btn-new">{{$ml.get('CANCEL')}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="relationshipField==='deleteContact'">
            <div class="row">
                <div class="col-12">
                    <label class="f-14 font-family-bold f-w-normal">{{$ml.get('CONTACT_TO_BE_DELETED')}}</label>
                    <input type="text" v-model="contactKeyword" @click="quickContact(),isHiddenOrganization=false" @blur="isHiddenOrganization=false" class="form-control border-radius-20 light-blue-border h-28 w-50">
                    <ul class="autocomplete-results" v-show='isHiddenContact'>
                        <li class="autocomplete-result" v-for='(result, i) in items' :key="i" @click="setResult(result,'deleteContact')">{{result.n}}</li>
                    </ul>
                    <ul class="autocomplete-results" v-show='items.length<1 && isHiddenContact'>
                        <li class="autocomplete-result" >{{$ml.get('NOT_FIND')}}!</li>
                    </ul>
                    <div v-show="contactDetail">
                        <div class="row mt-3">
                            <div class="col-12">
                                <i class="icon-line-kisi f-14"></i> {{contactKeyword}}
                            </div>
                            <div class="col-12 mt-3" v-if="contact!==undefined">
                                <label class="f-14 font-family-bold f-w-normal">{{$ml.get('CONTACT_DETAILS')}}</label>
                                <div v-if="contact.gsm!==undefined">
                                    <label class="f-14 font-family-bold f-w-normal w-100 p-0 m-0">Telefon</label>
                                    <label class="f-14 font-family-regular f-w-normal w-100 p-0 m-0">
                                        <i class="icon-line-telefon f-14"></i> {{contact.gsm}}
                                    </label>
                                </div>
                                <div v-if="contact.email!==undefined">
                                    <label class="f-14 font-family-bold f-w-normal w-100 p-0 m-0">{{$ml.get('EMAIL')}}</label>
                                    <label class="f-14 font-family-regular f-w-normal w-100 p-0 m-0">
                                    <i class="icon-line-mail f-14"></i> {{contact.email}}
                                    </label>
                                </div>
                            </div>
                           
                        </div>
                    </div>
                    <div v-if="deleteContact">
                        <label class="f-14 font-family-bold f-w-normal text-danger">Devam ederseniz <u>{{fullName}}</u> kişisini buradan silmiş olursunuz!</label>
                    </div>
                </div>
            </div>
        </div>
        
        <div v-if="relationshipField==='deal'">
            <div>
                <div class="font-md mb-3 font-weight-bold">{{$ml.get('CHANGE_PERSON')}}</div>
            </div>
            <div class="row">
                <div class="col-12">
                    <label class="new-label font-weight-bold">{{$ml.get('DEAL_TO_BE_ADDED')}}</label>
                    <div class="row" v-if="deal!==undefined">
                        <div class="col-12" v-if="deal.title!==undefined">
                            <input type="text" class="new-input" disabled :value="deal['title']">
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <label class="new-label font-weight-bold">{{$ml.get('CONTACT_TO_BE_ADDED_EDITED')}}</label>
                    <input type="text" v-model="contactKeyword" @click="quickContact(),isHiddenOrganization=false" @blur="isHiddenOrganization=false" class="new-input">
                    <ul class="new-dropdown autocomplete-results w-75" v-show='isHiddenContact'>
                        <li class="autocomplete-result" v-for='(result, i) in items' :key="i" @click="setResult(result,'contact')">{{result.n}} {{result.sn}}</li>
                    </ul>
                    <ul class="new-dropdown autocomplete-results" v-show='items.length<1 && isHiddenContact'>
                        <li class="autocomplete-result" >{{$ml.get('NOT_FIND')}}!</li>
                    </ul>
                </div>
            </div>
        </div>
        <div v-if="relationshipField==='organization'">
            <div>
                <div class="font-md mb-3 font-weight-bold">{{$ml.get('CHANGE_COMPANY')}}</div>
            </div>
            <div class="row">
                <div class="col-12">
                    <label class="new-label font-weight-bold">{{$ml.get('DEAL_TO_BE_ADDED')}}</label>
                    <div class="row" v-if="deal!==undefined">
                        <div class="col-12" v-if="deal.title!==undefined">
                            <input type="text" class="new-input" disabled :value="deal['title']">
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <label class="new-label font-weight-bold">{{$ml.get('COMPANY_WISHED_TO_BE_ADDED')}}</label>
                    <input type="text" v-model="organizationsKeyword" @click="isHiddenContact=false" class="new-input">
                    <ul class="new-dropdown autocomplete-results w-75" v-show='isHiddenOrganization'>
                        <li class="autocomplete-result" v-for='(result, i) in items' :key="i" @click="setResult(result,'organization')">{{result.name}}</li>
                    </ul>
                    <ul class="new-dropdown autocomplete-results" v-show='items.length<1 && isHiddenOrganization'>
                        <li class="autocomplete-result" >{{$ml.get('NOT_FIND')}}!</li>
                    </ul>
                </div>
            </div>
        </div>
        <div v-if="relationshipField==='product'">
            <div>
                <div class="font-md mb-3 font-weight-bold">{{$ml.get('PRODUCTS')}}</div>
            </div>
            <div class="row">
                <div class="col-12">
                    <table class="mcTable">
                        <thead class="mb-3">
                            <tr>
                                <th>{{$ml.get('PRODUCT_NAME')}}</th>
                                <th>{{$ml.get('PRICE')}}</th>
                                <th>{{$ml.get('PIECE')}}</th>
                                <th>{{$ml.get('DISCOUNT')}}</th>
                                <th>{{$ml.get('TOTAL')}}</th>
                                <th class="bg-transparent"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style="height: 10px;"></tr>
                            <tr v-for="(product,index) in data.productList" :key="index" class="disabled">
                                <td class="w-25 text-center">{{product.productId.name}}</td>
                                <td class="text-center"><input type="number" min="0" class="w-100 text-center" :disabled="selectProduct!=product._id.$oid" style="border: 0px;" @input="updateProductPriceList()" v-model.number="product.itemPrice" /></td>
                                <td ><input type="number" onwheel="this.blur()" :disabled="selectProduct!=product._id.$oid" class="w-100 text-center" style="border: 0px;" @input="updateProductPriceList()" v-model.number="product.quantity" /> </td>
                                <td ><input type="number" onwheel="this.blur()" :disabled="selectProduct!=product._id.$oid" min="0"  max="100" class="w-100 text-center" style="border: 0px;" @input="updateProductPriceList()" v-model.number="product.discountPercentage" /></td>
                                <td class="text-center" v-text="fixer(product.sum,2)"></td>
                                <td style="width: 200px;">
                                    <div class="d-flex align-items-center h-100">
                                        <i @click="selectProduct=product._id.$oid" v-if="selectProduct!=product._id.$oid" class="align-items-center p-2 text-success fa fa-pencil cursor-pointer"></i>
                                        <i @click="updateDealProduct(index)" v-if="selectProduct==product._id.$oid" class="d-flex align-items-center p-2 h-100 bg-success text-white fa fa-check cursor-pointer"></i>
                                        <i @click="deleteDealProduct(product._id.$oid)" v-if="selectProduct==product._id.$oid" class="d-flex align-items-center p-2 h-100 bg-danger text-white fa fa-trash cursor-pointer"></i>
                                        <i @click="selectProduct=undefined" v-if="selectProduct==product._id.$oid"  class="d-flex align-items-center p-2 h-100 text-danger text-white fa fa-close cursor-pointer"></i>
                                    </div>
                                </td>
                            </tr>

                            <tr v-if="data.productList==undefined">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-12">
                    <label class="new-label">{{$ml.get('ASSOCIATE_WITH_PRODUCT')}}</label>
                    <input type="text" v-model="productKeyword" class="new-input">
                    <ul class="new-dropdown autocomplete-results" v-show='isHiddenProduct'>
                        <li class="autocomplete-result" v-for='(result, i) in items' :key="i" @click="setResult(result,'product')">{{result.name}}</li>
                        <li class="autocomplete-result" v-if="items.length<1"> {{$ml.get('NOT_FIND')}}!!</li>
                    </ul>
                </div>
            </div>
        </div>
        <hr>
        <div class="row">
            <div class="col-12 dealBtnStyle">
                <button class="btn save" v-if="relationshipField!='product'" @click="save">{{$ml.get('SAVE')}}</button>
                <button class="btn" @click="cancel">{{$ml.get('CANCEL')}}</button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import {mapState} from 'vuex'
import {mapActions} from 'vuex'

import _ from 'underscore'
export default {
    name: 'relationship',
    data () {
        return {
            organization:[],
            contact:[],
            deal:[],
            items:[],
            product:[],
            pricesTotal:[],
            contactKeyword:'',
            organizationsKeyword:'',
            isHiddenProduct:false,
            isHiddenContact:false,
            isHiddenOrganization:false,
            selectOrganization:'',
            selectContact:'',
            dealId:"",
            contactId:'',
            organizationId:'',
            organizationDetail:false,
            contactDetail:false,
            fullName:"",
            dedectedOrganization:false,
            deleteContact:false,
            dealProductList:[],
            addContact:false,
            addContactArray:[],
            productKeyword:"",
            selectProduct:"",
        }
    },
    props:["data","permission"],
    computed: {
        ...mapState([
            'baseUrl',
            'relationshipField'
        ]),
    },
    methods:{

        validEmail: function (email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if(email.length>0&&email!==undefined){
                if(re.test(email)===false){
                    this.$notify({ group: 'foo',
                        type: 'warn', 
                        title: this.$ml.get('INVALID_EMAIL'),
                        text: this.$ml.get('PLEASE_INSERT_A_VALID_EMAIL')
                    })
                    return false
                }else{
                    return email
                }
            }else{
                return false
            }
        },
        postContact(url,obj){
             
            axios({
                method:'POST',
                url:`/${url}`,
                baseURL: this.baseUrl,
                data: obj,
                withCredentials:true
            }).then((res)=>{
                    return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: 'Kişi Eklendi!',
                        text: res.data.status.desc 
                    })
                    this.isHiddenContact = false
                    this.addContactArray=[]
                    this.addContact=false
                    this.items=[]

                    this.setResult(res.data.content.contact,'contact')
                     
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                     
                }
            })
        },
        saveContactButton(){
            let name="",surName,phone,mail,url;
            let nameSplit = []
            let dataObj={}
            nameSplit = this.addContactArray['name'].split(" ")
            if(nameSplit.length-1>0){
                for (let index = 0; index < nameSplit.length-1; index++) {
                    name=name+" "+nameSplit[index]
                }
                surName=nameSplit[nameSplit.length-1]
            }else{
                name=nameSplit[0]
            }
            phone=this.addContactArray['gsm']
            mail=this.addContactArray['mail']
            if(name.length>0 && mail!=null && phone!=null ){
                if(phone.length<9){
                    this.$notify({ 
                        group: 'foo',
                        type: 'warning', 
                        title: this.$ml.get('WARNING'),
                        text: this.$ml.get('PHONE_NUMBER_SHOULD_BE_AT_LEAST_10_DIGITS')
                    })
                }
                else if(!this.validEmail(mail)){
                    return false
                }else{ 
                    url = "addContact"
                    dataObj["contactInputObj"]={"n":name,"sn":surName,"gsm":phone,"email":mail}
                    this.postContact(url,dataObj)
                }
            }else{
                this.$notify({ 
                    group: 'foo',
                    type: 'warning', 
                    title: this.$ml.get('WARNING'),
                    text: this.$ml.get('REQUIRED_FIELDS_CANNOT_BE_BLANK')
                })
            }
        },
        closeContactButton(){
            this.addContact=false
            this.addContactArray['gsm']=""
            this.addContactArray['mail']=""
        },
        permissionSet(){
            if(this.permission===true){
                this.$notify({ 
                    group: 'foo',
                    type: 'error', 
                    title: this.$ml.get('ERROR'),
                    text: this.$ml.get('YOU_ARE_NOT_AUTHORIZED')
                })
                return true
            }else{
                return false
            }
        },
        updateProductPriceList(){
            for(var i in this.data.productList){
                this.data.productList[i].sum = (this.data.productList[i].itemPrice * this.data.productList[i].quantity) - (((this.data.productList[i].itemPrice * this.data.productList[i].quantity) * this.data.productList[i].discountPercentage)/100)
                this.data.productList[i].sum=parseFloat(this.data.productList[i].sum).toFixed(2)
            }
        },
        updateItemPrice(index,data){
            if(this.pricesTotal[index]===undefined){
                this.pricesTotal[index]=[]
            }
            this.pricesTotal[index].price=this.data.productList[index].productId.prices[0].price
            this.pricesTotal[index].price=parseInt(data.quantity)*parseInt(this.data.productList[index].productId.prices[0].price)
            let average=(this.pricesTotal[index].price*parseInt(data.discountPercentage))/100
            this.data.productList[index].quantity=parseInt(data.quantity)
            this.data.productList[index].discountPercentage=parseInt(data.discountPercentage)
            this.pricesTotal[index].price-=average
        },
        save(){
            if(this.relationshipField==="deal"){
                if(this.contactId!==undefined && this.contactId!==""){
                    let obj={}
                    obj={
                        contactId:{
                            "$oid":this.contactId
                        }
                    }
                    this.updateDeal(obj)
                }   
            }
            if(this.relationshipField==="organization"){
                if(this.organizationId!==undefined && this.organizationId!==""){
                    let obj={}
                    obj={
                        orgId:{
                            "$oid":this.organizationId
                        }
                    }
                    this.updateDeal(obj)
                }   
            }
            if(this.relationshipField==="contact"){
                if(this.contactId!==undefined && this.contactId!==""){
                    this.addOrganizationContact(this.contactId)
                }   
            }
            if(this.relationshipField==="deleteContact"){
                if(this.contactId!==undefined && this.contactId!==""){
                    this.removeOrganizationContact(this.contactId)
                }   
            }

            
        },
        cancel(){
            $("#relationship").modal("hide")
        },
        ...mapActions([
            'editRelationship',
            'updateLoading'
        ]),
        defined(){
            if(this.data.name!==undefined){
                this.organization = this.data
                this.organizationId=this.data._id.$oid
            }
            if(this.data.title!==undefined){
                this.deal = this.data
                if(this.data.orgId!==undefined){
                    this.organization=this.data.orgId
                    this.organizationId=this.data.orgId._id.$oid
                }else{
                    this.organizationId=""
                }
                if(this.data.contactId!==undefined){
                    this.contact=this.data.contactId
                }
                this.dealId=this.deal._id.$oid

            }
        },
        setResult(result,type){
            if(type==="contact"){
                if(this.relationshipField==='contact'){
                    if(result.organizationName!==undefined){
                        this.dedectedOrganization=true
                        this.selectOrganization=result.organizationName
                    }
                }
                this.contactDetail=true
                this.contactKeyword=result.n
                this.isHiddenContact= false
                this.contactId=result._id.$oid
                this.selectContact=result.n
                this.fullName=result.n + " "+ result.sn
            }
            if(type==="deleteContact"){
                this.contactDetail=true
                this.contactKeyword=result.n
                this.isHiddenContact= false
                this.contactId=result._id.$oid
                this.selectContact=result.n
                this.fullName=result.n + " "+ result.sn
                this.deleteContact=true
            }
            if(type==="organization"){
                this.organizationsKeyword=result.name
                this.isHiddenOrganization= false
                this.organizationId=result._id.$oid
                this.selectOrganization=result.name
                this.organizationDetail=true
            }
            if(type==="product"){
                
                this.isHiddenProduct= false
                this.productKeyword=""
                var productId=result._id.$oid
                var isProduct=false
                if(this.data.productList!=undefined){
                    isProduct=this.data.productList.filter(m => m.productId._id.$oid === productId).length===0
                }else{
                    isProduct=true
                }
                if(isProduct){
                    let obj={}
                    var currencyIs=false
                    for(var res in result.prices){
                        if(result.prices[res].currency==this.data.currency){
                            currencyIs=true
                            obj['dealId']={"$oid": this.dealId}
                            obj["itemPrice"]=result.prices[res].price
                            obj["quantity"]=1
                            obj["discountPercentage"]=0
                            obj["totalPrice"]=result.prices[res].price
                            obj["productId"]={"$oid": productId}
                        }
                    }
                    if(!currencyIs){
                        obj['dealId']={"$oid": this.dealId}
                        obj["itemPrice"]=0
                        obj["quantity"]=1
                        obj["totalPrice"]=0
                        obj["discountPercentage"]=0
                        obj["productId"]={"$oid": productId}
                    }
                    this.addDealProduct(obj)
                }

            }
        },
        updateDeal(obj){
             
            axios({
            method:'POST',
            url:'/updateDeal',
            baseURL: this.baseUrl,
            data: {
                dealId:this.dealId,
                dealUpdateObj:obj
            },
            withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==="0"){
                    $("#relationship").modal("hide")
                    this.$emit("updateData",res.data.content.deal)
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('SUCCESSFUL'),
                        text: res.data.status.desc 
                    })
                     
                }else if(res.data.status.code==="97"){
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: this.$ml.get('DEALS_CONTACT_AND_COMPANY_ASSOCIATED')
                    })
                     
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                     
                }
            })
        },
        addOrganizationContact(data){
             
            axios({
            method:'POST',
            url:'/addOrganizationContact',
            baseURL: this.baseUrl,
            data: {
                objId:this.organization._id.$oid,
                newContactId:data
            },
            withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status.code==0){
                    this.contactKeyword=""
                    this.contactId=""
                    this.dedectedOrganization=false
                    $("#relationship").modal("hide")
                    this.$emit("updateData",res.data.content.organization)
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('COMPANY_UPDATED'),
                        text: res.data.status.desc 
                    })
                     
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                     
                }
            })
        },
        removeOrganizationContact(data){
             
            axios({
            method:'POST',
            url:'/removeOrganizationContact',
            baseURL: this.baseUrl,
            data: {
                newContactId:data
            },
            withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status.code==0){
                    $("#relationship").modal("hide")
                    this.$emit("updateData",res.data.content.organization)
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('COMPANY_UPDATED'),
                        text: res.data.status.desc 
                    })
                     
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                     
                }
            })
        },
        quickProduct(){
             
            axios({
                method:'POST',
                url:'/quickFilterProduct',
                baseURL: this.baseUrl,
                data: {
                    search:this.productKeyword,
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.items=res.data.content.products
                    this.isHiddenProduct= true
                     
                }else{
                     
                }
            })
        },
        quickContact(){
             
            let obj={}
            if(this.relationshipField==='deal'){
                obj={
                    search:this.contactKeyword,
                    organizationId:this.organizationId
                }
                
            }else if(this.relationshipField==='contact'){
                obj={
                    search:this.contactKeyword,
                    organizationId:""
                }
            }else{
                obj={
                    search:this.contactKeyword,
                    organizationId:this.organizationId
                }
            }
            axios({
                method:'POST',
                url:'/quickFilterContact',
                baseURL: this.baseUrl,
                data: obj,
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.items=res.data.content.contacts
                    if(this.items.length>0){
                        this.isHiddenContact= true
                    }
                     
                }else{
                     
                }
            })
        },
        quickOrganization(){
             
            axios({
                method:'POST',
                url:'/quickFilterOrganization',
                baseURL: this.baseUrl,
                data: {
                    search:this.organizationsKeyword,
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.items=res.data.content.organizations
                    this.isHiddenOrganization= true
                     
                }else{
                     
                }
            })
        },
        addDealProduct(obj){
            var dataObje = {}
            dataObje['dealProductInputObj']=obj
             
            axios({
                method:'POST',
                url:"/addDealProduct",
                baseURL: this.baseUrl,
                data:dataObje,
                withCredentials:true
            }).then((res)=>{
                if(res.data.status.code==0){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: 'Ürün Eklendi!',
                        text: res.data.status.desc 
                    })
                    this.$emit("updateProduct")
                     
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'warn', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                     
                }
            })
            
        },
        updateDealProduct(i){
            
            if(this.permissionSet()){
                return false
            }
            
            let obj ={}
            let dataObje={}

            obj["itemPrice"]=this.data.productList[i].itemPrice
            obj["discountPercentage"]=this.data.productList[i].discountPercentage
            obj["quantity"]=this.data.productList[i].quantity
            
            dataObje['dealProductId']=this.data.productList[i]._id.$oid
            dataObje['dealProductUpdateObj']=obj
            
             
            axios({
                method:'POST',
                url:"/updateDealProduct",
                baseURL: this.baseUrl,
                data:dataObje,
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status.code==0){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: 'Ürün güncellendi!',
                        text: res.data.status.desc 
                    })
                    this.selectProduct=undefined
                    this.$emit("updateProduct")
                     
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'warn', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                     
                }
            })
            
        },
        deleteDealProduct(dealProductId){
            var dataObje = {}
            dataObje["dealProductId"]=dealProductId
             
            axios({
                method:'POST',
                url:"/deleteDealProduct",
                baseURL: this.baseUrl,
                data:dataObje,
                withCredentials:true
            }).then((res)=>{
                if(res.data.status.code==0){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: 'Ürün Silindi!',
                        text: res.data.status.desc 
                    })
                    this.$emit("updateProduct")
                     
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'warn', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                     
                }
            })
        },
        clear(){
            this.contactKeyword=""
            this.organizationsKeyword=''
        },
        fixer(val,fixTo){
            val = parseFloat(val)
            return val.toFixed(fixTo)
        },
        filterName:function(value){
            value=String(value)
            if ( value.length > 15 ) {
                return value.substring(0,15) + '...'
            } else {
                return value
            }
        }
    },
    created(){
    },
    mounted(){
    },
    watch: {
        contactKeyword: _.debounce(function() {
            this.addContactArray['name']=this.contactKeyword
            this.closeContactButton()
            if(this.contactKeyword==="" || this.contactKeyword===null){
                this.isHiddenContact=false
                this.contactDetail=false
            }else{
                if(this.selectContact!==this.contactKeyword){
                    this.isHiddenOrganization=false
                    this.quickContact() 
                }
            }
            
            
        }, 500),
        productKeyword: _.debounce(function(addr) {
            if(this.productKeyword===""){
                this.isHiddenProduct= false
            }else{
                this.quickProduct()
            }
        }, 300),
        organizationsKeyword: _.debounce(function(addr) {
            if(this.selectOrganization!==this.organizationsKeyword){
                this.isHiddenContact=false
                this.organizationDetail=false
                this.quickOrganization()
            }
            if(this.organizationsKeyword===""){
                this.isHiddenOrganization=false
                this.organizationId=""
            } 
        }, 500),
        data:function(){
            this.defined()
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dealBtnStyle button{
    height: 30px;
}
.autocomplete {
    position: relative;
    width: 130px;
}

.autocomplete-results {
    padding: 0;
    margin: 0;
    border: 1px solid #66D0FF80;
    height: 120px;
    overflow: auto;
    position: fixed;
    z-index: 9999;
    height: auto;
}


.mcTable {
    width: 100%;
    text-align: center;
}
.mcTable tr {
    height: 30px;
}
.mcTable thead tr th {
    padding-right: 3px;
    font-size: 11px;
    background-color: white;
    color: #53565E;
    font-weight: inherit;
    text-align: left !important;
    padding-left: 5px;
}


.mcTable td{
    font-size: 11px;
    background-color: #FFF;
    border: 1px solid #DEDFE1;
}
.mcTable td:last-child{
    background-color: inherit;
}
.iptal:before{
    color:red
}
</style>
